module.exports = __webpack_public_path__ + "img/BAU_Partners_9.342bea31.jpg";